import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, BoxProps, Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { isDemoDomain } from 'src/utils/common';
// import useResponsive from 'src/hooks/useResponsive';

// import { useSettingsContext } from '../settings/SettingsContext';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, sx, ...other }, ref) => {
    const theme = useTheme();

    // const isDesktop = useResponsive('up', 'lg');
    // const { themeLayout } = useSettingsContext();
    // const isNavMini = themeLayout === 'mini';

    const logoType = other.itemType;
    const isLight = theme.palette.mode === 'light';

    const logo = !(logoType === 'mini') ? (
      <Box
        component="img"
        src={
          isDemoDomain
            ? `/assets/images/logo${isLight ? '-color' : ''}.svg`
            : '/assets/images/logo_nhn_cloud_color.svg'
        }
        sx={{
          width: 100,
          cursor: 'pointer',
          filter: isDemoDomain || isLight ? 'none' : 'brightness(0) invert(1)',
          ...sx,
        }}
      />
    ) : (
      <Box
        component="img"
        src={
          isDemoDomain ? '/assets/images/logo-only.svg' : 'assets/images/logo_nhn_cloud_color.svg'
        }
        sx={{
          width: 50,
          height: 50,
          cursor: 'pointer',
          filter: isDemoDomain || isLight ? 'none' : 'brightness(0) invert(1)',
          ...sx,
        }}
      />
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} to="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  },
);

export default Logo;
